import { createBaseClient } from './factory';
import { createContentTypeJsonPlugin } from '../plugins/content-type-json';
import { InternalRequestInit } from '../types';
import { createWithBasicAuthPlugin } from '../plugins/with-basic-auth';
import { createWithGuestHeaderClientPlugin } from '@/src/lib/http/plugins/with-guest-header.client';
import { createWithSelfUrlPlugin } from '@/src/lib/http/plugins/with-self-url';
import { handleFetchResponse } from '@/src/lib/http/utils/handle-fetch-response';
import { createWithLocaleHeaderPluginClient } from '@/src/lib/http/plugins/with-locale.client';

export function createClient() {
  return createBaseClient<Omit<InternalRequestInit, 'withAuth'>>(
    {
      plugins: [
        createWithSelfUrlPlugin(),
        createContentTypeJsonPlugin(),
        createWithLocaleHeaderPluginClient(),
        createWithBasicAuthPlugin(),
        createWithGuestHeaderClientPlugin(),
      ],
    },
    handleFetchResponse,
  );
}
